import { Injectable, signal } from '@angular/core';
import { RELEASES } from './release-notes';

const SEEN_KEY = 'hyperion-release-notes-seen';

/**
 * Remembers per browser which release the user has last opened, so the
 * dashboard can point out news. Purely a convenience: without storage the
 * hint simply shows until the notes are opened in this session.
 */
@Injectable({ providedIn: 'root' })
export class ReleaseNotesService {
  private readonly latestKey = RELEASES[0]
    ? (RELEASES[0].version ?? `next-${RELEASES[0].items.length}`)
    : null;

  readonly hasUnseen = signal(
    !!this.latestKey && this.readSeen() !== this.latestKey
  );

  markSeen(): void {
    if (!this.latestKey) return;
    this.hasUnseen.set(false);
    try {
      localStorage.setItem(SEEN_KEY, this.latestKey);
    } catch {
      // storage unavailable (private mode, SSR) - hint reappears next visit
    }
  }

  private readSeen(): string | null {
    try {
      return localStorage.getItem(SEEN_KEY);
    } catch {
      return null;
    }
  }
}
